export default {
      id: "mastercard-usage",
      viewBox: "0 -2 32.003 24",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#mastercard",
      toString: function () {
        return this.url;
      }
    }